import { Injectable } from "@angular/core";
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from "@angular/common/http";
import { AuthenticateService } from "../authentication/authenticate.service";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class AuthInterceptor implements HttpInterceptor {
  constructor(public authService: AuthenticateService) {}
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (this.authService.user) {
      if (!this.authService.token) {
        let token = JSON.parse(
          localStorage.getItem(`${environment.name}.token`)
        );
        if (token) {
          let user: any = JSON.parse(
            localStorage.getItem(`${environment.name}.profile`)
          );
          if (user) {
            let phoneNo = user.phoneNo;
            this.authService.setUserLoggedIn(phoneNo, token, user);
          }
        }
      }
      request = request.clone({
        setHeaders: {
          auth_token: this.authService.token
            ? this.authService.token.accessToken
            : this.authService.user.authToken,
          client: "patient_android",
          phone_no: "" + this.authService.user.phoneNo,
        },
      });
    } else {
      request = request.clone({
        setHeaders: {
          client: "patient_android",
        },
      });
    }

    return next.handle(request);
  }

  getLocation(href: string) {
    const match = href.match(
      /^(https?\:)\/\/(([^:\/?#]*)(?:\:([0-9]+))?)([\/]{0,1}[^?#]*)(\?[^#]*|)(#.*|)$/
    );
    return (
      match && {
        href,
        protocol: match[1],
        host: match[2],
        hostname: match[3],
        port: match[4],
        pathname: match[5],
        search: match[6],
        hash: match[7],
      }
    );
  }
}
